import { SET_NOTIFICATIONS, SYNC_NOTIFICATIONS } from "../actions/types";

const initialData = {
  todayNotifications: [],
  olderNotifications: [],
  notSeenNotificationCount: 0,
  sync: false
};

//Hide and Show toast messages
export const nofiticationReducer = (state = initialData, { type, payload }) => {
  switch (type) {
    case SET_NOTIFICATIONS:
      return { ...state, ...payload };
    case SYNC_NOTIFICATIONS:
      return { ...state, ...payload };
    default:
      return state;
  }
};
